import api from "../apis/api";

class BookmarkService {
    getBookmarksService() {
        return api.bookmark.getBookmarks();
    }

    addBookmarksService(req) {
        return api.bookmark.addBookmarks(req);
    }

    tagBookmarksService(req) {
        return api.bookmark.tagBookmarks(req);
    }
}
export default new BookmarkService();
